(() => {
  if (window.__tlSocial) return;
  window.__tlSocial = true;
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const cards = [...root.querySelectorAll('.tl-social-card')];
    const track = root.querySelector('.tl-social-track');
    if (!cards.length) return;
    let active = 0;
    const playState = (card, playing) => {
      card.classList.toggle('is-playing', playing);
      card.querySelector('.tl-social-play').setAttribute('aria-pressed', String(playing));
    };
    function select(index, play = true) {
      active = ((index % cards.length) + cards.length) % cards.length;
      cards.forEach((card, i) => {
        const video = card.querySelector('video');
        card.classList.toggle('is-active', i === active);
        video.pause(); video.muted = true;
        card.querySelector('.tl-social-sound').textContent = '🔇';
        card.querySelector('.tl-social-sound').setAttribute('aria-pressed','false');
        card.querySelector('.tl-social-sound').setAttribute('aria-label',`Activar sonido del vídeo ${i + 1}`);
        playState(card, false);
        if (i === active && play) video.play().catch(() => playState(card, false));
      });
      const box = cards[active].getBoundingClientRect(), area = track.getBoundingClientRect();
      track.scrollTo({left:track.scrollLeft + box.left - area.left + box.width/2-track.clientWidth/2,behavior:'smooth'});
      root.querySelector('[data-social-status]').textContent = `Vídeo ${active + 1} de ${cards.length}`;
    }
    cards.forEach((card,i) => {
      const video = card.querySelector('video');
      card.querySelector('.tl-social-play').addEventListener('click',() => {
        if(i === active && !video.paused) video.pause(); else select(i);
      });
      card.querySelector('.tl-social-sound').addEventListener('click',() => {
        if (i !== active) select(i);
        video.muted = !video.muted;
        const sound = card.querySelector('.tl-social-sound');
        sound.textContent = video.muted ? '🔇' : '🔊';
        sound.setAttribute('aria-pressed',String(!video.muted));
        sound.setAttribute('aria-label',`${video.muted ? 'Activar' : 'Silenciar'} sonido del vídeo ${i + 1}`);
      });
      video.addEventListener('play',() => playState(card,true));
      video.addEventListener('pause',() => playState(card,false));
    });
    root.querySelector('[data-social-prev]').addEventListener('click',() => select(active-1));
    root.querySelector('[data-social-next]').addEventListener('click',() => select(active+1));
    new IntersectionObserver(entries => {
      if(!entries[0].isIntersecting) cards.forEach(c => c.querySelector('video').pause());
    },{threshold:0}).observe(root);
    document.addEventListener('visibilitychange',() => {if(document.hidden) cards.forEach(c=>c.querySelector('video').pause());});
    select(0,false);
  }
  const boot = (scope = document) => scope.querySelectorAll('[data-tl-social]').forEach(init);
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded',()=>boot()); else boot();
  document.addEventListener('shopify:section:load',e=>boot(e.target));
})();
